import {
  Box,
  Heading,
  Text,
  Button,
  useToast,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

// Use same-origin by default (so /api/... works in dev/prod)
const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

export default function AccountPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const toast = useToast();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1] || ''));
        setEmail(payload.sub || payload.email || '');
      } catch (err) {
        console.error('Failed to decode token:', err);
      }
    }
  }, []);

  const handleManageSubscription = async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Please log in.');

      // NEW: fetch a JSON link, then navigate
      const res = await fetch(`${API_BASE}/api/stripe/billing/portal/link`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include',
      });

      if (!res.ok) {
        const msg = (await res.text().catch(() => '')) || `HTTP ${res.status}`;
        throw new Error(msg);
      }

      const data = await res.json();
      if (!data?.url) throw new Error('No portal URL returned.');
      window.location.href = data.url; // actual redirect
    } catch (err) {
      const msg = err?.message || 'Something went wrong.';
      setError('Failed to redirect to Stripe portal.');
      console.error('Stripe portal error:', msg);
      toast({
        title: 'Stripe portal error',
        description: msg,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={20} p={6} borderWidth={1} borderRadius="lg">
      <Heading mb={4}>My Account</Heading>
      <Text mb={6}>Manage your subscription or billing details below.</Text>
      <Button
        colorScheme="green"
        onClick={handleManageSubscription}
        isLoading={loading}
        loadingText="Redirecting..."
        width="full"
        isDisabled={!email}
      >
        Manage Subscription
      </Button>
      {error && (
        <Text mt={4} color="red.500">
          {error}
        </Text>
      )}
    </Box>
  );
}
